import { Icon } from '@atom/mui';

import classes from './analyticsListEmpty.module.css';

interface Props {
  message?: string;
  icon?: string;
}

const AnalyticsListEmpty = ({
  message = 'This folder is empty',
  icon = 'folder',
}: Props) => (
  <div className={classes.emptyListContainer}>
    <Icon style={{ fontSize: '3.5rem' }} className={classes.emptyListIcon}>
      {icon}
    </Icon>
    <span className={classes.emptyListText}>{message}</span>
  </div>
);

export default AnalyticsListEmpty;
